import React from 'react'
const Loading = (props) => {
    const { main, className } = props;
    return <div className={main ? `${className} tb--btn-ternary tb--flex tb--justify-center tb--align-center` : `${className} tb--btn-secondary tb--flex tb--justify-center tb--align-center`} >
        <div className="lds-css ng-scope">
            <div className={main ? 'lds-spinner white-loader' : 'lds-spinner brand-loader'}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div >
}
export default Loading;